import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Icon from "../../../icon";
import { amazonHost } from "../../../paths";
import messages from "./messages";
import StoreBadges from "./StoreBadges/StoreBadges";
import { AppLogo, Connector1, Connector2, Container, Feature, FeatureDescription, Features, FeatureTitle, IconWrapper, Section } from "./styles";
import { features } from "./utils";

const MobileApp = () => {
    const { locale, formatMessage } = useIntl();
    const [orderedFeatures, setOrderedFeatures] = useState([]);
    useEffect(() => {
        window.addEventListener("resize", resize);
        resize();
        return () => {
            window.removeEventListener("resize", resize);
        }
    }, []);
    const resize = useCallback(() => {
        if (window.innerWidth < 768) {
            setOrderedFeatures(features.map((feature, index) => {
                if (index === 1) {
                    return [
                        feature[1],
                        feature[0],
                        feature[2],
                    ];
                }
                return feature;
            }));
        } else {
            setOrderedFeatures(features);
        }
    }, [setOrderedFeatures]);
    return (
        <Container>
            <AppLogo
                src={`${amazonHost}landing/app-logo.svg`}
            />
            <h2><FormattedMessage {...messages.title} /></h2>
            <p><FormattedMessage {...messages.description} /></p>
            <Features>
                {orderedFeatures.map((section, index) => (
                    <Section key={index}>
                        {section.map(feature => (
                            <Feature key={feature.icon}>
                                <IconWrapper>
                                    <Icon i={feature.icon} />
                                </IconWrapper>
                                <FeatureTitle>{formatMessage(feature.title)}</FeatureTitle>
                                {feature.description && (
                                    <FeatureDescription>{formatMessage(feature.description)}</FeatureDescription>
                                )}
                                {!feature.description && (
                                    <>
                                        <Connector1/>
                                        <Connector2/>
                                    </>
                                )}
                            </Feature>
                        ))}
                    </Section>
                ))}
            </Features>
            <StoreBadges />
        </Container>
    );
};

export default MobileApp;
